<template>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header border-0 pb-2">
        <p class="modal-title">
          <i class="fas fa-clock mr-2"></i>
          <span class="font-weight-bold">Session Timeout Warning</span>
        </p>
      </div>
      <div class="modal-body pt-2">
        <div class="px-3 py-2">
          <p class="text-muted mb-3 small">
            Your session will expire due to inactivity in:
          </p>
          <div class="text-center mb-4">
            <h3 class="timer-display font-weight-bold text-danger">
              {{ formattedTimeRemaining }}
            </h3>
          </div>
          <p class="text-muted small mb-4">
            You will be automatically logged out for your security. Click below to stay logged in.
          </p>
          <div class="d-flex justify-content-center">
            <button
              type="button"
              class="btn btn-sm btn-primary px-4"
              @click="extendSession"
            >
              <i class="fas fa-check mr-2"></i>
              Stay Logged In
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
p.modal-title i,
p.modal-title span {
  opacity: 0.7;
}

.modal-header {
  background-color: #f8f9fa;
}

.text-danger {
  color: #dc3545 !important;
}

.timer-display {
  letter-spacing: 0.05em;
  margin: 0;
  font-family: inherit;
}

.btn-sm {
  font-size: 0.875rem;
}
</style>

<script>
import { inactivity, events } from "../service";

export default {
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data() {
    return {
      timeRemaining: 120 // 2 minutes in seconds
    };
  },
  computed: {
    formattedTimeRemaining() {
      const minutes = Math.floor(this.timeRemaining / 60);
      const seconds = this.timeRemaining % 60;
      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    }
  },
  created() {
    this.startCountdown();
  },
  beforeDestroy() {
    this.stopCountdown();
  },
  methods: {
    startCountdown() {
      this.sync();
      this.intervalId = setInterval(() => this.sync(), 1000);
    },
    /**
     * Mirror the service's remaining time instead of running an independent
     * clock. Two separate countdowns drifted apart: the modal reached 0:00 and
     * froze while the service timeout kept being pushed forward, so the user
     * was never logged out.
     */
    sync() {
      this.timeRemaining = Math.ceil(inactivity.remaining / 1000);
      if (this.timeRemaining <= 0) this.stopCountdown();
    },
    stopCountdown() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    extendSession() {
      this.stopCountdown();
      inactivity.extend();
      // Emit event to close modal
      events.$emit('modal', { name: 'modal', data: {} });
    }
  }
};
</script>
